import Swiper from "swiper";
import { Navigation, A11y, Keyboard } from "swiper/modules";

/**
 * Swiper.js slider initialization
 *
 * options - Swiper.js slider options (optional)
 * @param {Function} callback - callback (optional)
 */
export const init = function (callback) {
  let swiperContainers = document.querySelectorAll(
    ".swiper-container.swiper-container--3"
  );

  swiperContainers.forEach(function (swiperContainer) {
    let cID = swiperContainer.getAttribute("id");
    let id = swiperContainer.querySelector(".swiper").getAttribute("id");

    let swiper = new Swiper(`#${id}`, {
      modules: [Navigation, Keyboard, A11y],
      speed: 500,
      slidesPerView: 1,
      spaceBetween: 30,
      // setWrapperSize: true,
      loop: true,
      centeredSlides: true,
      watchOverflow: true,
      navigation: {
        nextEl: `#${cID} .swiper-button-next`,
        prevEl: `#${cID} .swiper-button-prev`,
      },
      keyboard: { enabled: true },
      a11y: { enabled: true },
      on: {
        afterInit: function () {
          document.querySelector(`#${cID}`).classList.add("slider-init");
        },
      },
    });
  });
};
